import request from '@/utils/request'
// import axios from 'axios';

export function login(data) {
  return request({
    url: '/login/access-token',
    method: 'post',
    data,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization
        return data;
      }
    ]
  })
}

export function sendsms(data) {
  return request({
    url: '/login/sendsms',
    method: 'post',
    data,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization
        return data;
      }
    ]
  })
}

export function sendregsms(data) {
  return request({
    url: '/login/regsendsms',
    method: 'post',
    data
  })
}
/**
 * 查看当前用户信息
 */
export function getUser() {
  return request({
    url: '/member/',
    method: 'GET'
  })
}

/**
 * 给当前用户授权
 */
export function authorize(data) {
  return request({
    url: '/member/authorize',
    method: 'POST',
    data
  })
}

/**
 * 修改密码
 */
export function updatePassword(data) {
  return request({
    url: '/member/update_password',
    method: "PUT",
    data
  })
}

/**
 * 绑定用户
 */
export function bindUser(data) {
  return request({
    url: '/login/bindmember',
    method: 'POST',
    data
  })
}

/**
 * 刷新验证码
 */
export function refreshCode(params) {
  return request({
    url: '/login/refresh-validcode',
    method: 'get',
    params,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization
        return data;
      }
    ]
  })
}


/***
 * 通过短信验证码登录
 */
export function login_phone_sms(data) {
  return request({
    url: '/login/phone-access-token',
    method: 'post',
    data,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization
        return data;
      }
    ]
  })
}

/**
 * 获取二维码
 */
export function get_qrcode() {
  return request({
    url: '/member/myqrcode',
    method: 'GET'
  })
}
/**
 * 解绑微信
 */
export function unbind_wechat() {
  return request({
    url: '/member/unbind',
    method: 'POST'
  })
}
/**
 * 消息详情
 */
export function getMessage(id) {
  return request({
    url: '/member/msg_detail/' + id,
    method: 'GET'
  })
}
/**
 * 积分
 */
export function getScoreBill(params) {
  return request({
    url: '/member/point_logs',
    method: 'GET',
    params
  })
}
// export function getScoreBill(params) {
//   return axios({
//     url: 'https://mock.apifox.cn/m1/3135788-0-default/scores',
//     method: 'GET',
//     params
//   });
// }
